import React, {useEffect, useState} from 'react';
import {Card, Collapse, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {connect} from "react-redux";
import { withStyles } from "@mui/styles";
import {getRssNews} from "../../../../../state/actions/getRssNewsActions";

const styles = {
  card:{
    backgroundColor:'rgba(0, 89, 133, 0.08)',
    borderColor: 'rgb(0, 89, 133)',
    marginBottom: '1rem',
    position: 'relative',
    padding:'0.5rem',
    maxWidth: "960px",
    margin: "0 auto"
  },
  close:{
    position: 'absolute',
    right: '0.5rem',
    top: '0.5rem'
  },
  title:{
    marginRight: '2rem',
    display: 'flex',
    whiteSpace: 'nowrap',
    flexWrap: "wrap",
    gap: '0 0.25em',
    alignItems:"center",
  },
  titleLink:{
    display: 'flex',
    whiteSpace: 'nowrap',
    gap: '0 0.25em',
    alignItems:"center",
    width: 'fit-content',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  link:{
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  content:{
    marginTop:'1rem',
    display:'flex',
    flexWrap:'wrap',
    '& > p':{
      margin: '0 0.5rem'
    },
    '& > p:first-child':{
      '& > img':{
        maxWidth: '200px',
        maxHeight: '150px'

      }
    },
    '& > p:nth-child(2)':{
      minWidth: '250px',
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: '250px',
    },
    '& > p:last-child':{
      flexBasis: "100%",
      flexGrow: 1,
      width: "100%",
      textAlign:"center",
      margin:"0.25em auto 0"
    },

  }
};

function RssNews(props) {
  const { rssDismissTime, setRssDismissTime, viewOptsLoaded, newsItem, primaryMindfile, classes } = props;
  const [newsExpand, setNewsExpand] = useState(true);

  useEffect(() => {
    props.getRssNews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const pubTime = !!newsItem.pubDate ? new Date(newsItem.pubDate).getTime() : 0;
  const isOpen = pubTime > rssDismissTime;

  useEffect(() => {
    if(!primaryMindfile || !viewOptsLoaded || !newsItem || newsItem.skip){
      return;
    }
    if(!isOpen){
      setNewsExpand(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, viewOptsLoaded, newsItem, primaryMindfile])

  if(!primaryMindfile || !viewOptsLoaded || !newsItem || newsItem.skip){
    return null;
  }

  return (
    <div>
      <Collapse in={isOpen} unmountOnExit>
        <Card id="rssNews" variant="outlined" className={classes.card}>
          {/* todo: icon small */}
          <IconButton
            id="rssNewsClose"
            size="small"
            className={classes.close}
            onClick={() => setRssDismissTime(pubTime)}
          >
            <CloseIcon />
          </IconButton>
          <div>
            <div className={classes.title}>
              <strong>LifeNaut news:</strong>
              <div className={classes.titleLink}>
                <a id="rssNewsTitle" href={newsItem.link} className={classes.link}>{newsItem.title}</a>
                {/* todo: icon small */}
                <IconButton id="rssNewsCollapse" size="small" onClick={() => {
                  setNewsExpand(!newsExpand);
                }}>
                  {newsExpand ? <ExpandLess/> : <ExpandMore/>}
                </IconButton>
              </div>
            </div>
            <Collapse in={newsExpand} unmountOnExit>
              <div
                id="rssNewsContent"
                className={classes.content}
                dangerouslySetInnerHTML={{ __html: newsItem.content }}
              />
            </Collapse>
          </div>
        </Card>
      </Collapse>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    newsItem: state.rssNews,
    primaryMindfile: !!state.mindfile && !!state.auth && state.mindfile.id === state.auth.mid
  };
}

const mapDispatchToProps = {
  getRssNews
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RssNews));
